import { Box, Container, Typography } from '@mui/material'
import logo from '../../assets/images/logo.jpeg'

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        borderTop: '1px solid rgba(255,255,255,0.08)',
        py: 6,
        mt: 10,
      }}
    >
      <Container maxWidth="lg">
        
        {/* 🔥 Верхняя часть */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: { xs: 'flex-start', md: 'center' },
            justifyContent: 'space-between',
            gap: 3,
          }}
        >
          
          {/* ЛОГО */}
          <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{
              height: 100,
              width: 'auto',
              objectFit: 'contain',
            }}
          />

          {/* текст */}
          <Typography sx={{ color: 'rgba(255,255,255,0.6)' }}>
            Modern vending solutions for high-traffic business locations.
          </Typography>
        </Box>

        {/* 🔽 нижняя часть */}
        <Box
          sx={{
            mt: 4,
            pt: 3,
            borderTop: '1px solid rgba(255,255,255,0.08)',
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 2,
          }}
        >
          <Typography sx={{ color: 'rgba(255,255,255,0.4)', fontSize: 14 }}>
            © 2026 Aivo Smart. All rights reserved.
          </Typography>

          <Box sx={{ display: 'flex', gap: 2 }}>
            <Typography sx={{ color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }}>
              Privacy
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }}>
              Terms
            </Typography>
          </Box>
        </Box>

      </Container>
    </Box>
  )
}